import {Trans} from '@common/i18n/trans';
import { useForm, useFormContext } from 'react-hook-form';
import { FormSelect, Option } from '@common/ui/forms/select/select';
import { useTrans } from '@common/i18n/use-trans';
import { Item } from '@common/ui/forms/listbox/item';
import { CreateDocumentUploadPayload, CreateLoanDocumentPayload } from '@app_modules/requests/use-create-loan-document';
import { Button } from '@common/ui/buttons/button';
import { useDialogContext } from '@common/ui/overlays/dialog/dialog-context';
import { Dialog } from '@common/ui/overlays/dialog/dialog';
import { DialogHeader } from '@common/ui/overlays/dialog/dialog-header';
import { DialogBody } from '@common/ui/overlays/dialog/dialog-body';
import { DialogFooter } from '@common/ui/overlays/dialog/dialog-footer';
import { Form } from '@common/ui/forms/form';
import moment from 'moment-timezone';
import { CopyRateSheetPayload, useCopyRateSheet } from '@app_modules/requests/use-create-rate-sheet';

interface CopyRateSheetDialogProps {
  dateArray: string[];
  sourceDate: string;
  changeTargetDate: any;
}

export function CopyRateSheetDialog({ dateArray, sourceDate, changeTargetDate }: CopyRateSheetDialogProps) {
  const form = useForm<CopyRateSheetPayload>({
    defaultValues: { source_date: sourceDate, target_date: dateArray.at(-1) },
  });
  const { formId, close } = useDialogContext();
  const { trans } = useTrans();

  const copyRateSheet = useCopyRateSheet(form);
  return (
    <Dialog size="md">
      <DialogHeader>
        <Trans message="Copy Rate Sheet from " /> <span className='font-bold'>{moment.utc(sourceDate).format('MM/DD/YYYY')}</span>
      </DialogHeader>
      <DialogBody>
        <Form
          id={formId}
          form={form}
          // 
          onSubmit={values => {
            copyRateSheet.mutate(values, {
                onSuccess: (response:any) => {
                  changeTargetDate(response.target_date);
                  close();
                },
            });
          }}
        >
          <FormSelect
            name="target_date"
            selectionMode="single"
            autoFocus={true}
            required
            placeholder={trans({ message: 'Copy to' })}
            className="w-150 mb-20"
          >
            {dateArray.map((targetDate) =>
              sourceDate !== targetDate ? (
                <Item value={targetDate} key={targetDate}>
                  {moment.utc(targetDate).format('MM/DD/YYYY')}
                </Item>
              ) : null
            )}
          </FormSelect>
        </Form>
      </DialogBody>
      <DialogFooter>
        <Button
          variant="flat"
          color="orange"
          type="submit"
          form={formId}
          disabled={!form.watch('target_date')}
        >
          <Trans message="Copy" />
        </Button>
      </DialogFooter>
    </Dialog>
  );
}
